/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Range_CustomInputs */

const en_date_range_custom = /** @type {(inputs: Date_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom`)
};

const fr_date_range_custom = /** @type {(inputs: Date_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnalisé`)
};

const de_date_range_custom = /** @type {(inputs: Date_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brauch`)
};

const it_date_range_custom = /** @type {(inputs: Date_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costume`)
};

const ru_date_range_custom = /** @type {(inputs: Date_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обычай`)
};

const es_date_range_custom = /** @type {(inputs: Date_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costumbre`)
};

const zh_cn2_date_range_custom = /** @type {(inputs: Date_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`风俗`)
};

const ja_date_range_custom = /** @type {(inputs: Date_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタム`)
};

const hi_date_range_custom = /** @type {(inputs: Date_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिवाज़`)
};

const pt_pt2_date_range_custom = /** @type {(inputs: Date_Range_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizado`)
};

/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Date_Range_CustomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const date_range_custom = /** @type {((inputs?: Date_Range_CustomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Range_CustomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_date_range_custom(inputs)
	if (locale === "de") return de_date_range_custom(inputs)
	if (locale === "it") return it_date_range_custom(inputs)
	if (locale === "ru") return ru_date_range_custom(inputs)
	if (locale === "es") return es_date_range_custom(inputs)
	if (locale === "zh-CN") return zh_cn2_date_range_custom(inputs)
	if (locale === "ja") return ja_date_range_custom(inputs)
	if (locale === "hi") return hi_date_range_custom(inputs)
	if (locale === "pt-PT") return pt_pt2_date_range_custom(inputs)
	return en_date_range_custom(inputs)
});